var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamsCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_236",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.032,
    y1: 0.032,
    x2: 0.97,
    y2: 0.97,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5961c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a41ac"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams_Circle",
    transform: "translate(-322 -288)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 322, 288)",
    filter: "url(#Ellipse_236)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236-2",
    "data-name": "Ellipse 236",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(6 4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MS_teams",
    "data-name": "MS teams",
    transform: "translate(340 304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M41.6,19.2v6.4a4.8,4.8,0,1,1-9.6,0v-8h8A1.6,1.6,0,0,1,41.6,19.2Zm-4.8-4.8a3.2,3.2,0,1,0-3.2-3.2A3.2,3.2,0,0,0,36.8,14.4Z",
    transform: "translate(-5.6 -0.6)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M31,18.6v8.8a8,8,0,0,1-8.533,7.982A8.182,8.182,0,0,1,15,27.126V17H29.4A1.6,1.6,0,0,1,31,18.6Zm-8-4a4.8,4.8,0,1,0-4.8-4.8A4.8,4.8,0,0,0,23,14.6Z",
    transform: "translate(-2.2)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 5,
    cy: 4.5,
    rx: 5,
    ry: 4.5,
    transform: "translate(16 5.2)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M23.8,30.655V20H15V30.126a8.46,8.46,0,0,0,.755,3.474h5.1A2.945,2.945,0,0,0,23.8,30.655Z",
    transform: "translate(-2.2 -3)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M15,20V30.126a8.449,8.449,0,0,0,.443,2.674H20.77a2.5,2.5,0,0,0,2.5-2.5V20Z",
    transform: "translate(-2.2 -3)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M22.734,20H15V30.126A8.418,8.418,0,0,0,15.219,32h5.466a2.048,2.048,0,0,0,2.048-2.048V20Z",
    transform: "translate(-2.2 -3)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M18.4,30H5.6A1.6,1.6,0,0,1,4,28.4V15.6A1.6,1.6,0,0,1,5.6,14H18.4A1.6,1.6,0,0,1,20,15.6V28.4A1.6,1.6,0,0,1,18.4,30Z",
    transform: "translate(0 -1.8)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M16.441,19H9.932v1.376H12.37V27H14V20.375h2.438Z",
    transform: "translate(-1.186 -2.8)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsCircleIcon);
export default __webpack_public_path__ + "static/media/teams-circle-icon.643c8f688129596e0078bb5af3c3f928.svg";
export { ForwardRef as ReactComponent };